module.exports = __webpack_public_path__ + "static/img/13.8be46ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/sp/13.png
// module id = xS+g
// module chunks = 0